import React from 'react'
import { Navigate } from 'react-router-dom'
import { Outlet } from 'react-router'
import Sidebar from './sidebar'
import '../../css/components/public/dashboard.css'

const DashboardLayout = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    if(!User){
        return <Navigate to="/login"/>
    }
    else{
        if(User.role !== 'individual' && User.role !== 'business' && User.role !== 'wholesale'){
            return <Navigate to="/login"/>
        }
    }
  return (
    <div className='dashboard_wrapper'>
      <div className='dashboard_container'>
        <div className='dashboard_sidebar'>
            <Sidebar User={User}/>
        </div>
        <div className='dashboard_body'>
            <Outlet/>
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout
